export default {"src":"/_next/static/media/enerflo-platform-icon-flexibility.42663d98.svg","height":160,"width":160};